import { apiClient } from "./apiClient";

// Alarm kurallarını listele
export async function getAlarmRules(accessToken, edgeId = null) {
  const params = edgeId ? { edge_id: edgeId } : {};
  const res = await apiClient.get("/alarm-rules", {
    headers: { Authorization: `Bearer ${accessToken}` },
    params,
  });
  return res.data;
}

// Tek bir alarm kuralını getir
export async function getAlarmRule(accessToken, ruleId) {
  const res = await apiClient.get(`/alarm-rules/${ruleId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Yeni alarm kuralı oluştur
export async function createAlarmRule(accessToken, ruleData) {
  const res = await apiClient.post("/alarm-rules", ruleData, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Alarm kuralını güncelle
export async function updateAlarmRule(accessToken, ruleId, ruleData) {
  const res = await apiClient.put(`/alarm-rules/${ruleId}`, ruleData, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Alarm kuralını sil
export async function deleteAlarmRule(accessToken, ruleId) {
  const res = await apiClient.delete(`/alarm-rules/${ruleId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Alarm kuralını aktif/pasif yap
export async function toggleAlarmRule(accessToken, ruleId) {
  const res = await apiClient.post(`/alarm-rules/${ruleId}/toggle`, {}, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

// Koşul tipleri
export const CONDITION_TYPES = [
  { value: "GREATER_THAN", label: "Büyüktür (>)", symbol: ">", color: "#f85149" },
  { value: "LESS_THAN", label: "Küçüktür (<)", symbol: "<", color: "#58a6ff" },
  { value: "EQUALS", label: "Eşittir (=)", symbol: "=", color: "#8b949e" },
  { value: "BETWEEN", label: "Arasında", symbol: "↔", color: "#a371f7" },
];

// Aksiyon tipleri
export const ACTION_TYPES = [
  { value: "EMAIL", label: "Email", icon: "📧" },
];

// Sensör alanları
export const SENSOR_FIELDS = [
  { value: "temperature", label: "Sıcaklık", unit: "°C" },
  { value: "vibration", label: "Titreşim", unit: "mm/s" },
  { value: "pressure", label: "Basınç", unit: "kPa" },
  { value: "voltage", label: "Voltaj", unit: "V" },
  { value: "current", label: "Akım", unit: "A" },
];
